export const CountryConstants = {
    GET_COUNTRY: 'GET_COUNTRY',
    SET_COUNTRY: 'SET_COUNTRY'
};